import React from 'react';
import wrapperSize from './WrapperSize';

export const Context = React.createContext();

class ContainerProvider extends React.Component {
  constructor(props) {
    super(props);

    this.margin = {
      top: 60,
      bottom: 40,
      left: 40,
      right: 40
    };
  }

  get w() {
    const {
      margin: { right, left }
    } = this;
    const { width } = this.props;
    return width - right - left;
  }

  get h() {
    const {
      margin: { bottom, top }
    } = this;
    const { height } = this.props;
    return height - bottom - top;
  }

  render() {
    const { width, height, children, data, id: containerId } = this.props;
    const {
      w,
      h,
      margin,
      margin: { top, left, bottom, right }
    } = this;

    return (
      <Context.Provider
        value={{ width, height, margin, w, h, data, containerId }}
      >
        {children}
      </Context.Provider>
    );
  }
}

ContainerProvider.defaultProps = {
  width: 600,
  height: 300
};

export default wrapperSize(ContainerProvider);
